// Mock of the countries.json API
// TODO: replace with actual request to the API

export type CountryConfig = {
    country: string;
    region: string;
    mainRegionCountry: string;
};

export const countriesConfig: CountryConfig[] = [
    {
        country: 'US',
        region: 'US',
        mainRegionCountry: 'US',
    },
    {
        country: 'CA',
        region: 'CA',
        mainRegionCountry: 'CA',
    },
    {
        country: 'AR',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'MX',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'BO',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'CL',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'CO',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'CR',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'DO',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'EC',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'GT',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'HN',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'NI',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'PA',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'PE',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'PY',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'SV',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'UY',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'VE',
        region: 'LATAM',
        mainRegionCountry: 'MX',
    },
    {
        country: 'BR',
        region: 'BR',
        mainRegionCountry: 'BR',
    },
    {
        country: 'AU',
        region: 'AU',
        mainRegionCountry: 'AU',
    },
    {
        country: 'NO',
        region: 'NO',
        mainRegionCountry: 'NO',
    },
    {
        country: 'SJ',
        region: 'NO',
        mainRegionCountry: 'NO',
    },
    {
        country: 'SE',
        region: 'SE',
        mainRegionCountry: 'SE',
    },
    {
        country: 'DK',
        region: 'DK',
        mainRegionCountry: 'DK',
    },
    {
        country: 'FO',
        region: 'DK',
        mainRegionCountry: 'DK',
    },
    {
        country: 'GL',
        region: 'DK',
        mainRegionCountry: 'DK',
    },
    {
        country: 'FI',
        region: 'FI',
        mainRegionCountry: 'FI',
    },
    {
        country: 'AX',
        region: 'FI',
        mainRegionCountry: 'FI',
    },
    {
        country: 'GB',
        region: 'GB_IE',
        mainRegionCountry: 'GB',
    },
    {
        country: 'GG',
        region: 'GB_IE',
        mainRegionCountry: 'GB',
    },
    {
        country: 'JE',
        region: 'GB_IE',
        mainRegionCountry: 'GB',
    },
    {
        country: 'IM',
        region: 'GB_IE',
        mainRegionCountry: 'GB',
    },
    {
        country: 'IE',
        region: 'GB_IE',
        mainRegionCountry: 'GB',
    },
    {
        country: 'BL',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'FR',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'GF',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'GP',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'MF',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'MQ',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'PM',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'RE',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'YT',
        region: 'FR',
        mainRegionCountry: 'FR',
    },
    {
        country: 'IT',
        region: 'IT',
        mainRegionCountry: 'IT',
    },
    {
        country: 'VA',
        region: 'IT',
        mainRegionCountry: 'IT',
    },
    {
        country: 'SM',
        region: 'IT',
        mainRegionCountry: 'IT',
    },
    {
        country: 'DE',
        region: 'GSA',
        mainRegionCountry: 'DE',
    },
    {
        country: 'AT',
        region: 'GSA',
        mainRegionCountry: 'DE',
    },
    {
        country: 'CH',
        region: 'GSA',
        mainRegionCountry: 'DE',
    },
    {
        country: 'ES',
        region: 'ES',
        mainRegionCountry: 'ES',
    },
    {
        country: 'EU_UNSUPPORTED',
        region: 'EU_UNSUPPORTED',
        mainRegionCountry: 'EU_UNSUPPORTED',
    },
    {
        country: 'NON_EU_UNSUPPORTED',
        region: 'NON_EU_UNSUPPORTED',
        mainRegionCountry: 'NON_EU_UNSUPPORTED',
    },
];

export const countryToRegionMap: Readonly<Record<string, string>> = Object.freeze(
    Object.fromEntries(
        countriesConfig.map((c) => [c.country.toLowerCase(), c.region.toLowerCase()]),
    ),
);

export const regionToMainCountryMap: Readonly<Record<string, string>> = Object.freeze(
    Object.fromEntries(
        countriesConfig.map((c) => [c.region.toLowerCase(), c.mainRegionCountry.toLowerCase()]),
    ),
);

export type RegionToCountriesMap = Record<string, string[]>;

// returns a map of regions to countries
// { latam: ['mx', ...], gsa: ['de' ...], ... }
export const mapRegionToCountries = (
    config: readonly CountryConfig[] = countriesConfig,
): RegionToCountriesMap =>
    config.reduce<RegionToCountriesMap>((map, { country, region }) => {
        const key = region.toLowerCase();
        if (!map[key]) {
            map[key] = [];
        }
        map[key].push(country.toLowerCase());
        return map;
    }, {});

export const regionToCountriesMap: Readonly<RegionToCountriesMap> =
    Object.freeze(mapRegionToCountries());
